import { Controller } from '@hotwired/stimulus';

// 賃金台帳の期間指定 (#3118)。年・月のプルダウンを hidden の "YYYY-MM" へ
// まとめる。サーバは from / to をこの形式で受け取るため、プルダウンを
// 変えたときと送信時の両方で同期する。
export default class extends Controller {
  static targets = ['fromYear', 'fromMonth', 'toYear', 'toMonth', 'from', 'to'];

  connect() {
    this.sync();
  }

  sync() {
    if (this.hasFromTarget) {
      this.fromTarget.value = this.combine(this.fromYearTarget, this.fromMonthTarget);
    }
    if (this.hasToTarget) {
      this.toTarget.value = this.combine(this.toYearTarget, this.toMonthTarget);
    }
  }

  combine(yearEl, monthEl) {
    return `${yearEl.value}-${String(monthEl.value).padStart(2, '0')}`;
  }
}
